import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/* Saved commentary sections for the signed-in user + toggle. */
export function useCommentaryBookmarks() {
  const { user, openAuth } = useAuth();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["commentary-bookmarks"], queryFn: async () => (await api.get("/commentary-bookmarks")).data, enabled: !!user, staleTime: 60 * 1000 });
  const ids = new Set(data?.section_ids || []);
  const toggle = useMutation({
    mutationFn: async ({ slug, sectionId, saved }) => (saved ? api.delete(`/commentary-bookmarks/${slug}/${sectionId}`) : api.post(`/commentary-bookmarks/${slug}/${sectionId}`)),
    onSuccess: (_, v) => { qc.invalidateQueries({ queryKey: ["commentary-bookmarks"] }); toast.success(v.saved ? "Removed from My Study." : "Saved to My Study."); },
    onError: () => toast.error("Couldn't update that bookmark."),
  });
  const setNote = useMutation({
    mutationFn: async ({ slug, sectionId, note }) => (await api.patch(`/commentary-bookmarks/${slug}/${sectionId}`, { note })).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["commentary-bookmarks"] }); toast.success("Note saved."); },
    onError: () => toast.error("Couldn't save the note."),
  });
  return {
    bookmarks: data?.bookmarks || [],
    setNote: (slug, sectionId, note) => setNote.mutateAsync({ slug, sectionId, note }),
    noteSaving: setNote.isPending,
    isSaved: (slug, sectionId) => ids.has(`${slug}/${sectionId}`),
    toggle: (slug, sectionId) => { if (!user) { openAuth(); return; } toggle.mutate({ slug, sectionId, saved: ids.has(`${slug}/${sectionId}`) }); },
    pending: toggle.isPending,
  };
}
